var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 9.16667C0 6.73552 0.965771 4.40394 2.68485 2.68485C4.40394 0.965771 6.73552 0 9.16667 0H34.8333C37.2645 0 39.5961 0.965771 41.3151 2.68485C43.0342 4.40394 44 6.73552 44 9.16667V22H31.1667C28.7355 22 26.4039 22.9658 24.6849 24.6849C22.9658 26.4039 22 28.7355 22 31.1667V44H9.16667C6.73552 44 4.40394 43.0342 2.68485 41.3151C0.965771 39.5961 0 37.2645 0 34.8333V9.16667ZM25.6667 43.483C26.9635 43.0282 28.1414 42.2876 29.1133 41.316L41.316 29.1097C42.2858 28.1384 43.0251 26.9618 43.4793 25.6667H31.1667C29.708 25.6667 28.309 26.2461 27.2776 27.2776C26.2461 28.309 25.6667 29.708 25.6667 31.1667V43.483Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewNode);
export default __webpack_public_path__ + "static/media/NewNode.315de49cfaf9cc0a51ef8cca84545d6a.svg";
export { ForwardRef as ReactComponent };